import { isDev } from "../app/utils";
import {
  DniImageType,
  DocumentRepresentativeType,
  DocumentType,
} from "../types";

export const firestoreCollections = {
  dni: "dniImages",
  dniSignatory: "dniImagesSignatory",
  liveness: "livenessValidation",
  livenessSignatory: "livenessValidationSignatory",
};

// docs mapped to the backend document types
export const documentTypesParsed: Record<
  DniImageType | string,
  DocumentType | DocumentRepresentativeType
> = {
  frontDNI: "DNI_FRONT",
  backDNI: "DNI_BACK",
};


export const showOnlyInDev = isDev